import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

export const useIsCardPullEnabled = () => {
  const {
    flags: { enabledCardPullPerSport = [] },
  } = useFeatureFlags();
  const { sport } = useSportContext();

  return enabledCardPullPerSport.includes(sport.toLowerCase());
};
